module.exports = __webpack_public_path__ + "img/shachen.c2b27a0e.png";